import { configureStore } from "@reduxjs/toolkit";
import modelReducer from "./features/modelSlice";
import detectReducer from "./features/detectSlice";
import authReducer from "./features/authSlice.js";


const store = configureStore({
  reducer: {
    model: modelReducer,
    detection: detectReducer,
    auth: authReducer // Add login slice reducer here
  },
});

export default store;